import { Ebbne, MountWithEbbne, useEbbne, useEbbnenContext } from "@solidwhite/ebbnen";
import Section from "../../Section";
import RoundedPlaneGeometry from "../../RoundedPlaneGeometry";
import SubSection from "../../SubSection";
import PowerFloor from "./PowerFloor";
import Powerrail from "./powerrail/Powerrail";
import { Suspense } from "react";
import LoadingCallback from "../../../LoadingCallback";
import StaticCharge from "./StaticCharge";
import DynamicCharge from "./DynamicCharge";
import { UIPortal } from "@solidwhite/ui-portal";
import SideBar, { SideBarHider } from "../../../ui/SideBar/SideBar";

const ChargeProducts = ({ nodes, ...props }) => {
  return (
    <Ebbne id="c-products">
      <MountWithEbbne>
        <SideBarHider />
      </MountWithEbbne>

      <group position={nodes.products.position} rotation={nodes.products.rotation}>
        <Section object3d={nodes.products} />
        <MountWithEbbne mountedWhen={"visible"}>
          <RoundedPlaneGeometry radius={0.1} lenght={8.217031} width={7.011687} height={40} curveSegments={32} />
        </MountWithEbbne>

        <Ebbne id="p-powerrail" visibleWithAbove={2}>
          <SubSection object3d={nodes.p_powerrail} hideWhenActive />
          <MountWithEbbne mountedWhen="active-and-below">
            <group position={nodes.p_powerrail.position}>
              <Suspense fallback={<LoadingCallback />}>
                <Powerrail />
              </Suspense>
            </group>
          </MountWithEbbne>
        </Ebbne>

        <Ebbne id="p-powerfloor" visibleWithAbove={2}>
          <SubSection object3d={nodes.p_powerfloor}>
            <MountWithEbbne>
              <PowerFloor object3d={nodes.p_powerfloor} />
            </MountWithEbbne>
          </SubSection>
        </Ebbne>

        <Ebbne id="p-dynamic-charge" visibleWithAbove={2}>
          <SubSection object3d={nodes.dynamic_charge}>
            <MountWithEbbne>
              <DynamicCharge object3d={nodes.dynamic_charge} />
            </MountWithEbbne>
          </SubSection>
        </Ebbne>

        <Ebbne id="p-static-charge" visibleWithAbove={2}>
          <SubSection object3d={nodes.static_charge}>
            <MountWithEbbne>
              <StaticCharge object3d={nodes.static_charge} />
            </MountWithEbbne>
          </SubSection>
        </Ebbne>
      </group>
    </Ebbne>
  );
};

export default ChargeProducts;
